export const CREATE_EVENT_MODULE_ID = 'events-create-event-module';

export const LOAD_CREATE_EVENT_MODULE = () =>
  import('@capital-access/events/create-event').then(m => m.EventsCreateEventModule);
